if (!customElements.get('html-renderer')) {
  class HtmlRenderer extends HTMLElement {
    static get observedAttributes() {
      return ['content'];
    }

    constructor() {
      super();
      this.attachShadow({ mode: 'open' });
    }

    connectedCallback() {
      this._render();
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (oldValue !== newValue) {
        this._render();
      }
    }

    _render() {
      const raw = this.getAttribute('content') || '';
      this.shadowRoot.innerHTML = this._stripScripts(raw);
    }

    _stripScripts(html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      doc.querySelectorAll('script').forEach((el) => el.remove());
      return doc.body.innerHTML;
    }
  }

  customElements.define('html-renderer', HtmlRenderer);
}
